import { Eip1193Provider } from 'ethers'
import { useEffect } from 'react'

import { modal } from '@/contexts'
import { globalStore } from '@/stores/global'
import { walletInfoAtom, walletProviderAtom } from '@/stores/wallet'

export const useAppkitInit = () => {
  useEffect(() => {
    console.log('modal', modal)

    const unsubscribeWalletInfo = modal?.subscribeWalletInfo((walletInfo) => {
      globalStore.set(walletInfoAtom, walletInfo)
    })

    const unsubscribeProviders = modal?.subscribeProviders((providers) => {
      const provider = providers['eip155'] as Eip1193Provider
      globalStore.set(walletProviderAtom, provider)
    })

    return () => {
      unsubscribeWalletInfo?.()
      unsubscribeProviders?.()
    }
  }, [])
}
